export { CarouselBig } from './carousel-big'
